import React from "react";
import { useDraftPreview } from "../context/SiteContentContext";
import { Eye } from "lucide-react";

/** Small fixed banner shown when the site is being viewed with ?draft=1 and the
 * admin session is valid enough to fetch draft content. */
export default function DraftPreviewBanner() {
  const isDraftPreview = useDraftPreview();
  if (!isDraftPreview) return null;
  const exitDraft = () => {
    if (typeof window === "undefined") return;
    const url = new URL(window.location.href);
    url.searchParams.delete("draft");
    window.location.href = url.toString();
  };
  return (
    <div
      data-testid="draft-preview-banner"
      className="fixed top-0 inset-x-0 z-[100] bg-[#D8A936] text-[#0B0B0C] text-[11px] tracking-[0.16em] uppercase font-semibold flex items-center justify-center gap-3 py-2 px-4 shadow-lg"
    >
      <Eye size={13} />
      <span>Draft preview — you are seeing unpublished copy</span>
      <button
        type="button"
        onClick={exitDraft}
        data-testid="draft-preview-exit"
        className="border border-[#0B0B0C]/40 px-2 py-0.5 hover:bg-[#0B0B0C] hover:text-[#D8A936] transition-colors"
      >
        Exit
      </button>
    </div>
  );
}
